import styled from "styled-components";

export const GroupInfoLoadingSkeletonContainer = styled.div`
  max-width: 365px;

  margin-top: 7.5rem;

  @media (max-width: 768px) {
    margin-top: 5rem;
  }

  @media (max-width: 500px) {
    margin-top: 3rem;
  }

  .title {
    margin-bottom: 1rem;
  }

  .progress {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .tags {
    display: flex;
    gap: 0.75rem;

    flex-wrap: wrap;

    margin-bottom: 1rem;
  }

  .buttons {
    gap: 0.75rem;
    display: flex;
    margin-top: 1rem;
  }
`;
